<header class="flex flex-col w-full bg-surface">
  <div class="w-full flex flex-col">
    @if (overline) {
      <span class="soft-overline">
        {{overline}}
      </span>
    }
    @if (title) {
      <span class="font-bold">
        {{title}}
      </span>
    }
    @if (subtitle) {
      <span class="text-light text-xs mt-1">
        {{subtitle}}
      </span>
    }
  </div>
  <ng-content></ng-content>
</header>
